import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import {
  AsyncPipe,
  DOCUMENT,
  NgComponentOutlet,
  NgStyle,
} from '@angular/common';
import { HttpClientService } from '@app/services/util-services/root-services/http-client.service';
import {
  APIRequestBodyModel,
  ContainerItemModel,
  ContainerModel,
} from '@app/models/server/layout.model';
import { HttpErrorResponse, HttpParams } from '@angular/common/http';
import { B2bDynamicLibModule } from '@app/b2b-dynamic-lib/b2b-dynamic-lib.module';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ToastService } from '@app/services/util-services/root-services/toast-service';
import {
  delay,
  from,
  Observable,
  of,
  Subscription,
  switchMap,
  tap,
} from 'rxjs';
import { StorageUtilLibService } from '@b2b/storage-util-lib';
import { STORAGE_CONST } from '@app/constants/storage-constants';
import { B2bDeviceUtilService } from '@app/services/util-services/root-services/b2b-device-util.service';

@Component({
  selector: 'app-b2b-dynamic-data-card',
  templateUrl: './b2b-dynamic-data-card.component.html',
  styleUrls: ['./b2b-dynamic-data-card.component.scss'],
  standalone: true,
  imports: [NgStyle, B2bDynamicLibModule, AsyncPipe, NgComponentOutlet],
})
export class B2bDynamicDataCardComponent implements OnInit, OnDestroy {
  @Input() compData: {
    container: ContainerModel;
    containerItem?: ContainerItemModel;
    pageType?: string;
  };

  @Output() selectEvent: EventEmitter<any> = new EventEmitter<any>();

  @Output() componentLoadedEvent: EventEmitter<any> = new EventEmitter<any>();

  dynamicContainers: ContainerModel[];

  // dynamicContainersObservable: Observable<any>;

  params: Params;
  apiRequestBody: APIRequestBodyModel;

  errorContainers: ContainerModel[] = [];

  // isLoaded: boolean = Boolean(false);

  showLoader: boolean = Boolean(true);
  routeDynamicDataCardSubscription$: Subscription;
  getDynamicContainersSubscription$: Subscription;

  minHeight: number;

  // animationState: string;
  // finishAnimationSubject: Subject<any> = new Subject<any>();
  // finishAnimationSubscription$: Subscription;

  constructor(
    private httpClientService: HttpClientService,
    private route: ActivatedRoute,
    private toastService: ToastService,
    private storageUtilLibService: StorageUtilLibService,
    private router: Router,
    @Inject(DOCUMENT) private readonly document,
    private b2bDeviceUtilService: B2bDeviceUtilService, // private ngZone: NgZone,
  ) {
    this.params = this.route?.snapshot?.queryParams;
  }

  ngOnInit() {
    this.routeDynamicDataCardSubscription$ = this.route.queryParams.subscribe({
      next: (params: Params) => {
        // LoggerService.log(
        //   'Inside B2bFooterButtonComponent new query params ',
        //   params
        // );
        this.params = params;
      },
    });

    this.init();
    // this.onLoaded();
  }

  init() {
    this.initDataLoading();
    /*if (this.b2bDeviceUtilService?.isServer()) {
          this.initDataLoading();
        } else {
          this.ngZone.runOutsideAngular(() => {
            this.initDataLoading();
          });
        }*/
  }

  initDataLoading() {
    if (this.compData?.container) {
      if (this.compData?.container?.sliderMinHeight) {
        this.minHeight = this.compData?.container?.sliderMinHeight;
      } else if (this.compData?.container?.skeletonHeight) {
        this.minHeight = this.compData?.container?.skeletonHeight;
      }
    } else if (this.compData?.containerItem) {
      this.minHeight = this.compData?.containerItem?.sliderMinHeight;
      if (this.compData?.containerItem?.sliderMinHeight) {
        this.minHeight = this.compData?.containerItem?.sliderMinHeight;
      } else if (this.compData?.containerItem?.skeletonHeight) {
        this.minHeight = this.compData?.containerItem?.skeletonHeight;
      }
    }

    this.onLoaded();
  }

  setLoader() {
    /* if (this.compData?.container?.key === 'list_container') {
           this.showLoader = true;
         } else if (this.compData?.containerItem?.key === 'list_container') {
           this.showLoader = true;
         }*/
    this.showLoader = true;
    this.componentLoadedEvent.emit();
  }

  hideLoader() {
    this.showLoader = false;
  }

  onComponentLoaded() {
    // this.animationState = SKELETON_STATES.finish;
  }

  onSelectEvent(event: any) {
    this.selectEvent.emit(event);
  }

  onLoaded() {
    this.setLoader();

    // this.showLoader = true;
    if (this.compData?.container) {
      this.apiRequestBody = this.compData?.container?.apiRequestBody;
      this.initDynamicContainers(
        this.compData?.container?.apiURL,
        this.compData?.container?.isCacheEnabled,
        this.compData?.container?.key,
      );
    } else if (this.compData?.containerItem) {
      this.apiRequestBody = this.compData?.containerItem?.apiRequestBody;
      this.initDynamicContainers(
        this.compData?.containerItem?.apiURL,
        this.compData?.containerItem?.isCacheEnabled,
        this.compData?.containerItem?.key,
      );
    } else {
      console.warn('B2B:Warning Dynamic data configuration is not correct.');
      this.hideLoader();
    }
  }

  initDynamicContainers(api: string, isCacheEnabled: boolean, key: string) {
    /*this.checkCacheData(api, isCacheEnabled, key).pipe(
          switchMap((containers: ContainerModel[]) => {

            this.showLoader = false;
            if (containers?.length > 0) {
              this.dynamicContainers = containers;
            } else {

              this.dynamicContainers = [];
            }
            this.isLoaded = true;



            return of(this.dynamicContainers);
          }),
          catchError((errorResponse: HttpErrorResponse) => {

            if (errorResponse?.error?.errorContainer) {
              this.errorContainers = errorResponse.error.errorContainer;
            } else {

            }
            this.showLoader = false;
            this.isLoaded = true;
            return of([]);
          })
        );*/

    this.checkCacheData(api, isCacheEnabled, key)
      .pipe(
        switchMap((containers: ContainerModel[]) => {
          if (containers?.length > 0) {
            this.dynamicContainers = containers;
          } else {
            this.dynamicContainers = [];

            if (!this.b2bDeviceUtilService?.isServer()) {
              const element = this.document?.getElementById(key);

              if (element) {
                element.remove();
              }
            }
          }
          return of(containers);
        }),
        delay(1000),
      )
      .subscribe({
        next: (containers: ContainerModel[]) => {
          // this.isLoaded = true;

          this.hideLoader();
        },
        error: (errorResponse: HttpErrorResponse) => {
          // this.toastService.showApiError(errorResponse);

          if (errorResponse?.error?.errorContainer) {
            this.errorContainers = errorResponse.error.errorContainer;
          } else {
          }
          this.hideLoader();
          // this.isLoaded = true;
        },
      });
  }

  ngOnDestroy(): void {
    if (this.routeDynamicDataCardSubscription$) {
      this.routeDynamicDataCardSubscription$.unsubscribe();
    }
    if (this.getDynamicContainersSubscription$) {
      this.getDynamicContainersSubscription$.unsubscribe();
    }
    // if (this.finishAnimationSubscription$) {
    //   this.finishAnimationSubscription$?.unsubscribe();
    // }
  }

  ionViewDidLeave() {
    if (this.routeDynamicDataCardSubscription$) {
      this.routeDynamicDataCardSubscription$.unsubscribe();
    }
    if (this.getDynamicContainersSubscription$) {
      this.getDynamicContainersSubscription$.unsubscribe();
    }
  }

  private checkCacheData(
    api: string,
    isCacheEnabled: boolean,
    key: string,
  ): Observable<ContainerModel[]> {
    let urlPath = this.router?.url;
    if (urlPath && urlPath?.includes('?')) {
      urlPath = urlPath.substring(0, urlPath.indexOf('?'));
    }

    let cacheKey: string;

    if (!this.b2bDeviceUtilService.isDesktop()) {
      cacheKey = `${STORAGE_CONST.MOBILE_PAGE_DATA_CACHE_PREFIX_ENUM}${
        STORAGE_CONST.DYNAMIC_CACHE_PREFIX_ENUM
      }${urlPath?.toLowerCase()}_${key}${
        STORAGE_CONST.PAGE_DATA_CACHE_SUFFIX_ENUM
      }`;
    } else {
      cacheKey = `${STORAGE_CONST.DESKTOP_PAGE_DATA_CACHE_PREFIX_ENUM}${
        STORAGE_CONST.DYNAMIC_CACHE_PREFIX_ENUM
      }${urlPath?.toLowerCase()}_${key}${
        STORAGE_CONST.PAGE_DATA_CACHE_SUFFIX_ENUM
      }`;
    }

    // const tempKey: string = urlPath + '_' + key;

    if (isCacheEnabled) {
      return from(this.storageUtilLibService.get(cacheKey, false)).pipe(
        switchMap((res: any) => {
          if (res) {
            return of(res);
          } else {
            return this.getDynamicContainers(api).pipe(
              tap((containers: ContainerModel[]) => {
                this.storageUtilLibService
                  ?.set(cacheKey, containers, false)
                  .then();
              }),
            );
          }
        }),
      );
    } else {
      return this.getDynamicContainers(api);
    }
  }

  private getDynamicContainers(api: string): Observable<ContainerModel[]> {
    if (this.apiRequestBody?.method === 'GET') {
      let httpParams: HttpParams = new HttpParams();
      if (
        this.apiRequestBody?.queryParams &&
        Object.entries(this.apiRequestBody?.queryParams)?.length > 0
      ) {
        httpParams = httpParams.appendAll(this.apiRequestBody?.queryParams);
      }

      /*return this.httpClientService.get(
              `${api}?${this.apiRequestBody?.queryParamsString}`,
              {},
            );*/
      return this.httpClientService.get(
        `${api}`,
        {
          params: httpParams,
        },
        true,
      );
      // .pipe(delay(15000));
    } else {
      return this.httpClientService.post(
        api,
        {
          queryParams: this.params,
          apiRequestBody: this.apiRequestBody,
        },
        {},
        true,
      );
      // .pipe(delay(15000));
    }
  }
}

/*@NgModule({
  declarations: [B2bDynamicDataCardComponent],
  imports: [
    CommonModule,
    ShellModule,
    B2bDynamicLibModule,
    RouterModule,
    B2bInViewPortLibModule,
    B2bLoadersModule,
  ],
})
export class B2bDynamicDataCardModule {}*/
